import React from "react";
import { useMediaQuery } from "@mui/material";
import PartnerTennetImage from '/Images/partnertennet.svg';

const PartnerSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E8E4E1",
      padding: isMobile ? "40px 20px" : "100px 0px 100px 100px", // Remove right padding on desktop
      borderRadius: "10px",
      textAlign: isMobile ? "center" : "left",
    },
    textContainer: {
      width: isMobile ? "100%" : "50%",
      marginBottom: isMobile ? "20px" : "0",
    },
    imageContainer: {
      width: isMobile ? "100%" : "50%",
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-end",
      
    },
    image: {
      width: "100%",
      maxWidth: isMobile ? "300px" : "600px",
    },
    heading: {
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontSize: isMobile ? "24px" : "40px",
      fontWeight: "bold",
      lineHeight: "1.2",
      marginBottom: "20px",
      width: isMobile? "auto" :"641px"
    },
    paragraph: {
      color: "#636363",
      fontSize: isMobile ? "0.875rem" : "1rem",
      lineHeight: "1.6",
      marginBottom: "30px",
      width: "620px",
      textAlign: "justify",
    },
  };

  return (
    <div style={styles.container}>
      {/* Text Container */}
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Building a Stronger Ecosystem  
          for Digital Assets Together
        </h2>
        <p style={styles.paragraph}>
          At Tennet, we are proud to have collaborated with a network of esteemed partners who
          share our vision for the future of digital assets. By working closely with industry
          leaders, innovators, and trusted institutions, we are not only enhancing our service
          offerings but also contributing to the growth of a secure ecosystem for digital assets.
          We believe that collaboration is the key to unlocking the full potential of the digital
          economy. Through these partnerships, Tennet is committed to driving innovation, improving
          security standards, and building a more resilient infrastructure for the digital asset industry.
          Our partnerships are more than just business relationships—they are strategic alliances that
          strengthen the foundation of the global digital asset market, ensuring long-term trust
          and sustainability for all.
        </p>
      </div>

      {/* Image Container */}
      <div style={styles.imageContainer}>
        <img src={PartnerTennetImage} alt="Partner Logos" style={styles.image} />
      </div>
    </div>
  );
};

export default PartnerSection;
